var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.65673 10.9422C0.372712 11.2262 0.372712 11.6867 0.65673 11.9707C0.940747 12.2547 1.40123 12.2547 1.68525 11.9707L6.31348 7.34244L10.9417 11.9707C11.2257 12.2547 11.6862 12.2547 11.9702 11.9707C12.2542 11.6867 12.2542 11.2262 11.9702 10.9422L7.342 6.31392L11.9704 1.68548C12.2545 1.40146 12.2545 0.940979 11.9704 0.656961C11.6864 0.372944 11.2259 0.372944 10.9419 0.656962L6.31348 5.2854L1.68503 0.656962C1.40102 0.372944 0.940532 0.372944 0.656515 0.656962C0.372497 0.940979 0.372497 1.40146 0.656515 1.68548L5.28496 6.31392L0.65673 10.9422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7912db9016246bcbdae150968820cc03.svg";
export { ForwardRef as ReactComponent };